import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgBingoBall = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M1.905 12C1.905 6.425 6.425 1.905 12 1.905S22.095 6.425 22.095 12 17.575 22.095 12 22.095 1.905 17.575 1.905 12M12 3.405a8.595 8.595 0 1 0 0 17.19 8.595 8.595 0 0 0 0-17.19"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="m11.264 12.541-1.495-.178.327-3.89h4.217v1.415h-2.96l-.118 1.307a1.87 1.87 0 0 1 1.168-.396c1.465 0 2.356 1.03 2.356 2.395 0 1.456-1.139 2.495-2.653 2.495-1.466 0-2.545-.772-2.752-2.178l1.603-.257c.09.663.515 1.079 1.139 1.079s1.109-.456 1.109-1.099c0-.634-.406-1.129-1.05-1.129-.425 0-.723.198-.89.436"
      />
    </svg>
  );
};
export default SvgBingoBall;
